export const getConditionalRowStyles = (expanded) => [
    {
      when: (data) => data.user_id && !!expanded[data.user_id],
      style: {
       
      },
    },
  ];
export  const customExpandableIcon = {
  collapsed: <span className='collapsed-icon'></span>,
  expanded: <span className='expand-icon'></span>,
};


export const customDataTableStyles = {
  table: {
    style: {
      // backgroundColor: '',
      borderRadius: '8px',
    },
  },
  rows: {
    style: {
      minHeight: '52px',
      fontSize: '13px',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#b9b7b79e',
      minHeight: '52px',
      fontSize: '11px',
      fontWeight: '600',
      color:'#495a69',
    },
  },
  cells: {
    style: {
      paddingLeft: '16px',
      paddingRight: '16px',
      color:'#495a69',
      // border:"1px solid red",

    },
  },
  pagination: {
    style: {
      borderTop: "1px solid #cbeceff5",
      backgroundColor: "#f9f9fb",
      borderRadius: "0 0 8px 8px", // Rounded bottom corners
    },
  },
};

